import { topicsData } from '@/mocks/home';

const colorMap: Record<string, string> = {
  primary: 'bg-primary-100 text-primary-700 hover:bg-primary-200',
  accent: 'bg-accent-100 text-accent-700 hover:bg-accent-200',
  secondary: 'bg-secondary-100 text-secondary-700 hover:bg-secondary-200',
};

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold mb-3">
            全网热议
          </span>
          <h2 className="text-2xl md:text-4xl font-bold text-foreground-950">
            热议话题
          </h2>
          <p className="mt-3 text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            综艺圈最热话题标签，加入讨论分享你的观点
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {topicsData.map((topic) => (
            <a
              key={topic.id}
              href="#topics"
              className={`px-4 py-2.5 rounded-full text-sm font-medium transition-colors cursor-pointer whitespace-nowrap no-underline ${colorMap[topic.color]}`}
            >
              <span className="font-semibold">#</span> {topic.name}
              <span className="ml-2 text-xs opacity-70">{topic.count}</span>
            </a>
          ))}
        </div>

        <div className="text-center mt-8">
          <button className="px-6 py-2.5 bg-secondary-500 text-background-50 rounded-lg text-sm font-medium hover:bg-secondary-600 transition-colors whitespace-nowrap cursor-pointer">
            查看更多话题
            <i className="ri-arrow-right-line ml-1"></i>
          </button>
        </div>
      </div>
    </section>
  );
}